import axios, { AxiosInstance } from "axios";

export function createStripeAdapterAxiosClient(): AxiosInstance {
  return axios.create({
    baseURL: import.meta.env.VITE_STRIPE_ADAPTER_BASE_URL,
  });
}
